import { useEffect, useRef } from 'react';

export default function EmotionalHookSection() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            el.querySelectorAll('.hook-animate').forEach((child, i) => {
              (child as HTMLElement).style.animationDelay = `${i * 0.15}s`;
              child.classList.add('animate-fade-in-up');
            });
            obs.unobserve(el);
          }
        });
      },
      { threshold: 0.15 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <section ref={ref} className="relative w-full py-24 md:py-32 bg-background-950">
      <div className="w-full px-6 md:px-10 lg:px-16">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="hook-animate opacity-0 text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-foreground-50 leading-tight tracking-tight mb-8">
            Sometimes{' '}
            <span className="text-primary-500">&ldquo;wish you were here&rdquo;</span>{' '}
            is not enough.
          </h2>
          <p className="hook-animate opacity-0 text-foreground-400 text-lg md:text-xl max-w-2xl mx-auto leading-relaxed mb-16">
            You cannot always be at the same bar. You can still buy them a drink. MARKER turns distance into a reason to meet up.
          </p>

          {/* Visual flow */}
          <div className="hook-animate opacity-0 flex flex-wrap items-center justify-center gap-4 md:gap-6">
            {[
              { icon: 'ri-smartphone-line', label: 'Phone' },
              { icon: 'ri-goblet-line', label: 'Drink' },
              { icon: 'ri-user-heart-line', label: 'Friend' },
              { icon: 'ri-store-3-line', label: 'Bar' },
            ].map((item, i) => (
              <div key={item.label} className="flex items-center gap-4 md:gap-6">
                <div className="flex flex-col items-center gap-3">
                  <div className="w-16 h-16 md:w-20 md:h-20 rounded-2xl bg-background-100 border border-background-200/50 flex items-center justify-center">
                    <i className={`${item.icon} text-2xl md:text-3xl text-primary-500`} />
                  </div>
                  <span className="text-foreground-500 text-xs font-medium uppercase tracking-wider">{item.label}</span>
                </div>
                {i < 3 && (
                  <div className="hidden md:flex items-center">
                    <i className="ri-arrow-right-line text-primary-500 text-xl" />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}